import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
var LegacyListboxInternalContext = /*#__PURE__*/React.createContext(undefined);

var LegacyListboxInternalContextProvider = function LegacyListboxInternalContextProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      labelMap = _React$useState2[0],
      setLabelMap = _React$useState2[1];

  var value = React.useMemo(function () {
    return {
      labelMap: labelMap,
      setLabelMap: setLabelMap
    };
  }, [labelMap, setLabelMap]);
  return /*#__PURE__*/React.createElement(LegacyListboxInternalContext.Provider, {
    value: value
  }, children);
};

function useLegacyListboxInternalContext() {
  var ctx = React.useContext(LegacyListboxInternalContext);

  if (!ctx) {
    throw new Error("useLegacyListboxInternalContext should be used inside LegacyListboxInternalContext");
  }

  return ctx;
}

export { LegacyListboxInternalContextProvider, useLegacyListboxInternalContext };